"use strict";

module Patersons {
  export class MarketValue {
    date: string;
    value: number;
    grossCost: number;
    netCost: number;
  }

  export class MarketValueReport extends AbstractReport {
    marketValuation: MarketValue[];
  }

  export class MarketValueReportComponent implements ng.IComponentOptions {
    templateUrl: string =
      "assets/templates/portfolioSummary/components/marketValueReport.component.html";
    controller: any = MarketValueReportController;
    bindings: any = {
      account: "<",
      displayTitle: "@",
      asAt: "<"
    };
  }
  export interface MarketValueReportScope extends ng.IScope {
    userCompany: UserCompany;
    events: Patersons.MarketValueReportController;

    loadedOnce: boolean;

    isMarketValueLoading: boolean;
    isMarketValueError: boolean;
    hasMarketValueData: boolean;

    marketValueReport: MarketValueReport;

    fromDate: Date;
    toDate: Date;
    selectedPeriod: string;

    periodFilter: any[];

    chartData: any;
    chartLabels: any;
    chartSeries: any;
    chartOptions: any;
    datasetOverride: any;
  }

  export class MarketValueReportController extends AbstractReportController {
    account: Account;
    asAt: Date;
    userCompanyService: Patersons.UserCompanyService;
    scope: Patersons.MarketValueReportScope;
    reportService: Patersons.ReportService;
    $rootScope: any;
    static $inject = [
      "$scope",
      "$rootScope",
      "userCompanyService",
      "reportService",
    ];
    constructor($scope, $rootScope, userCompanyService, reportService) {
      super();
      this.scope = $scope;
      this.$rootScope = $rootScope;
      this.scope.events = this;
      this.userCompanyService = userCompanyService;
      this.reportService = reportService;
      this.scope.fromDate = moment(this.asAt).add(-1, "Y").toDate();
      this.scope.toDate = moment(this.asAt).toDate();
      this.scope.selectedPeriod = "1Y";
      this.scope.periodFilter = [
        {
          id: "ALL",
          text: "All",
          fromDate: moment(this.asAt).add(-100, "Y").toDate(),
          toDate: moment(this.asAt).toDate(),
          unit: undefined
        },
        {
          id: "5Y",
          text: "5Y",
          fromDate: moment(this.asAt).add(-5, "Y").toDate(),
          toDate: moment(this.asAt).toDate(),
          unit: "year"
        },
        {
          id: "1Y",
          text: "1Y",
          fromDate: moment(this.asAt).add(-1, "Y").toDate(),
          toDate: moment(this.asAt).toDate(),
          unit: "month"
        },
        {
          id: "6M",
          text: "6M",
          fromDate: moment(this.asAt).add(-6, "M").toDate(),
          toDate: moment(this.asAt).toDate(),
          unit: "month"
        },
        {
          id: "1M",
          text: "1M",
          fromDate: moment(this.asAt).add(-1, "M").toDate(),
          toDate: moment(this.asAt).toDate(),
          unit: "day"
        },
      ];

      this.scope.chartOptions = {
        maintainAspectRatio: false,
        tooltips: {
          mode: "index",
          intersect: false,
          backgroundColor: '#FFF',
          titleFontSize: 16,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          xPadding: 10,
          yPadding: 10,
          caretSize: 0,
          caretPadding: 10,
          titleSpacing: 4,
          cornerRadius: 0,
          bodyFontSize: 14,
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              return tooltipItem.yLabel.toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
              });
            },
          },
        },
        elements: {
          point: {
            radius: 0,
          },
          line: {
            tension: 0,
            fill: false,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                maxTicksLimit: 6,
                callback: function (value, index, values) {
                  return value.toLocaleString("en-AU", {
                    style: "currency",
                    currency: "AUD",
                  });
                },
              },
            },
          ],
          xAxes: [
            {
              type: "time",
              time: {
                unit: "month",
                minUnit: "day",
                tooltipFormat: "DD MMMM YYYY", 
                displayFormats: {
                  quarter: "MMM YYYY",
                },
              },
            },
          ],
        },
      };

      this.scope.datasetOverride = [
        {
          type: "LineWithLine",
        },
      ];

      this.userCompanyService.getUserCompany().then((company) => {
        this.scope.userCompany = company;
        if (company.enableFeature) {
          this.load();
        }
      });
    }
    load() {
      this.getMarketValueReport();
    }

    setFromDate(selectedDate) {
      this.scope.fromDate = selectedDate;
      this.scope.selectedPeriod = null;
      this.getMarketValueReport();
    }

    setToDate(selectedDate) {
      this.scope.toDate = selectedDate;
      this.scope.selectedPeriod = null;
      this.getMarketValueReport();
    }

    setSelectedPeriod(selectedPeriod) {
      this.scope.toDate = selectedPeriod.toDate;
      this.scope.fromDate = selectedPeriod.fromDate;
      this.scope.selectedPeriod = selectedPeriod.id;
      this.scope.chartOptions.scales.xAxes[0].time.unit = selectedPeriod.unit;
      this.getMarketValueReport();
    }

    buildChartData() {
      this.scope.chartSeries = ["Market Value for " + this.account.accountId];

      const seriesData = this.scope.marketValueReport.marketValuation.map(
        (element) => {
          return {
            x: moment(element.date).toDate(),
            y: element.value,
          };
        }
      );

      if(this.scope.selectedPeriod === "ALL"){
        if(seriesData.length > 365){
          this.scope.chartOptions.scales.xAxes[0].time.unit = "year";
        }else{
          this.scope.chartOptions.scales.xAxes[0].time.unit = "month";
        }
      }

      this.scope.chartData = [seriesData];
    }

    getMarketValueReport = function () {
      this.scope.isMarketValueError = false;
      this.scope.hasMarketValueData = false;

      if (this.account == undefined) {
        return;
      }

      this.scope.isMarketValueLoading = true;

      this.reportService
        .getReport(
          ReportType.MarketValue,
          this.account.accountId,
          this.scope.fromDate,
          this.scope.toDate
        )
        .then(
          (result) => {
            this.scope.marketValueReport = result as MarketValueReport;
            this.buildChartData();
            this.scope.hasMarketValueData = true;
            this.scope.isMarketValueError = false;
            this.scope.loadedOnce = true;
          },
          (error) => {
            // error handling
            this.scope.marketValueReport = null;
            this.scope.isMarketValueError = true;
            this.scope.hasMarketValueData = false;
          }
        )
        .finally(() => {
          this.scope.isMarketValueLoading = false;
        });
    };
  }
}
